var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg06Dizzy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    width: 240,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n#bot{transform-origin:120px 200px;animation:wobble 1.3s ease-in-out infinite}\n@keyframes wobble{0%,100%{transform:rotate(-7deg)}50%{transform:rotate(7deg)}}\n#swL{transform-origin:90px 116px;animation:spin 1.1s linear infinite}\n#swR{transform-origin:150px 116px;animation:spin 1.1s linear infinite reverse}\n@keyframes spin{to{transform:rotate(360deg)}}\n#stars{transform-origin:120px 44px;animation:orbit 1.6s linear infinite}\n@keyframes orbit{to{transform:rotate(360deg)}}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bot"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 58,
    width: 160,
    height: 150,
    rx: 52,
    fill: "#6FE3D0"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#0E2A2E",
    strokeWidth: 6,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "swL",
    d: "M90 116 m0,-4 a4,4 0 1,1 -4,4 a8,8 0 1,1 8,8 a13,13 0 1,1 -13,-13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "swR",
    d: "M150 116 m0,-4 a4,4 0 1,1 -4,4 a8,8 0 1,1 8,8 a13,13 0 1,1 -13,-13"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98 158 q11 -12 22 0 q11 12 22 0",
    fill: "none",
    stroke: "#0E2A2E",
    strokeWidth: 8,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "stars",
    fill: "#FFD84D",
    stroke: "#0E2A2E",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 20 l5 12 13 2 -9 9 2 13 -11 -6 -11 6 2 -13 -9 -9 13 -2 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 46 l4 9 10 1 -7 7 2 10 -9 -5 -9 5 2 -10 -7 -7 10 -1 z",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 46 l4 9 10 1 -7 7 2 10 -9 -5 -9 5 2 -10 -7 -7 10 -1 z",
    opacity: 0.85
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg06Dizzy);
export default __webpack_public_path__ + "static/media/06-dizzy.f25c3a40c897adea9669779333d32fcf.svg";
export { ForwardRef as ReactComponent };